import { createFileRoute } from '@tanstack/react-router';
import { TeamLeavePage } from '@/features/leave/team-leave-page';
import { guardRoute } from '@/lib/route-guards';

/** `/team/leave` (FR-LEAVE-8): my reporting tree's leave calendar. */
export const Route = createFileRoute('/_app/team_/leave')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/team/leave');
  },
  component: TeamLeavePage,
});
